import React, { useEffect, useCallback, useMemo, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate, useParams } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { Config } from "../../../Utils/Config";
import moment from "moment";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import { Label } from "reactstrap";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { encryptPayload } from "../../../Utils/crypto_utils";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const UserSubscription = (props) => {
  const navigate = useNavigate();
  const { userid, orderid } = useParams();
  const packageDetail = props.packDetails;
  const [isLoading, setLoading] = React.useState(false);
  const [UserSubscription, setUserSubscription] = useState([]);
  const [orderBy, setOrderBy] = useState("invoiceNumber");
  const [sortDirection, setSortDirection] = useState("DESC");

    const tableHeaders = [
    { label: "Invoice Number", align: "left", key: "invoiceNumber", sorting: true },
    { label: "Payment Date", align: "center", key: "invoiceDate", sorting: true },
    { label: "Term", align: "center", key: "interval" },
    { label: "Currency", align: "center", key: "currency" },
    { label: "Amount", align: "center", key: "amount" },
    { label: "Valid From", align: "center", key: "periodFrom", sorting: true },
    { label: "Valid Until", align: "center", key: "periodTo", sorting: true },
    { label: "View", align:"right"},
  ];

  useEffect(() => {
    getUserInfo();
  }, []);

  const getUserInfo = async () => {
    // let encryptedPayload = await encryptPayload(parseInt(orderid));
    setLoading(true);
    const posturl = "/Subscription/billingdetails";
    // const geturl = `/subscription/billinghistory/${encodeURIComponent(
    //   encryptedPayload
    // )}`;
    // userid
    //   ? apiCommonTrigger("post", Config.API_URL + posturl, {
    //       userid: userid,
    //       orderid: orderid,
    //     })
    //   :
    apiCommonTrigger("post", Config.API_URL + posturl, {
      userid: userid,
      orderid: orderid,
    })
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          setUserSubscription(res.data);          
        } else {
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        setLoading(false);
        handlingCatchError(err, navigate);
      });
  };

  const handleSortingData = (column, direction) => {
    let subscriptionData = [...UserSubscription];
    const sortedData = subscriptionData.sort((a,b)=>{
      if(direction === "ASC"){
        if(a[column] < b[column]) return -1;
        if(a[column] > b[column]) return 1;
        return 0;
      } else {
        if(a[column] > b[column]) return -1;
        if(a[column] < b[column]) return 1;
        return 0;
      }
    });    
    setUserSubscription(sortedData);
  }

  const handleSorting = (column) => {
    if (orderBy === column) {
      setSortDirection(sortDirection === "ASC" ? "DESC" : "ASC");
      handleSortingData(column, sortDirection === "ASC" ? "DESC" : "ASC");
    } else {
      setOrderBy(column);
      setSortDirection("ASC");
      handleSortingData(column, "ASC");
    }
  };

  return (
    <div>
      {isLoading ? (
        <div className="loader-wrap">
          <div className="loading loading-center"></div>
        </div>
      ) : (
        ""
      )}
      <Row>
        <Col>
          <div className="common-table">
            <h2>User Billing Details</h2>
            <div className="my-markets-table">
              <TableContainer
                component={Paper}
                className="table-design"
                // ref={scrollTableRef}
                style={{ maxHeight: 450, overflow: "auto" }}
              >
                <Table sx={{ minWidth: 650 }} stickyHeader>
                  <TableHead>
                    <TableRow>
                     {tableHeaders?.map(({ label, align, sorting, key }, index) => {
                      return <TableCell key={index} align={align}>
                            <span
                              onClick={() => sorting && handleSorting(key)}
                              style={{
                                cursor: sorting ? "pointer" : "default",
                                fontWeight: orderBy === key ? "bold" : "",
                              }}
                            >
                            {label}
                              {sorting &&
                                (orderBy === key ? (
                                  sortDirection === "ASC" ? (
                                    <ArrowUpwardOutlinedIcon fontSize="small" />
                                  ) : (
                                    <ArrowDownwardOutlinedIcon fontSize="small" />
                                  )
                                ) : (
                                  <ArrowDownwardOutlinedIcon
                                    fontSize="small"
                                    style={{ opacity: 0.3 }}
                                  />
                                ))}
                            </span>
                          </TableCell>
                     })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {UserSubscription && UserSubscription?.length > 0 ? (
                      UserSubscription.map((subscription) => (
                        <TableRow>
                          <TableCell align="left">
                            <Label className="mb-0">
                              {subscription.invoiceNumber || "-"}
                            </Label>
                          </TableCell>
                          <TableCell align="center">
                            {moment(subscription.invoiceDate).format(
                              "DD-MMM-YYYY"
                            ) === "Invalid date"
                              ? "-"
                              : moment(subscription.invoiceDate).format(
                                  "DD-MMM-YYYY"
                                )}
                          </TableCell>
                          <TableCell align="center">
                            {subscription.interval || "-"}
                          </TableCell>
                          <TableCell align="center">
                            {subscription.currency || "-"}
                          </TableCell>
                          <TableCell align="center">
                            {subscription.amount || "-"}
                          </TableCell>
                          <TableCell align="center">
                            {moment(subscription.periodFrom).format(
                              "DD-MMM-YYYY"
                            ) === "Invalid date"
                              ? "-"
                              : moment(subscription.periodFrom).format(
                                  "DD-MMM-YYYY"
                                )}
                          </TableCell>
                          <TableCell align="center">
                            {moment(subscription.periodTo).format(
                              "DD-MMM-YYYY"
                            ) === "Invalid date"
                              ? "-"
                              : moment(subscription.periodTo).format(
                                  "DD-MMM-YYYY"
                                )}
                          </TableCell>
                          <TableCell align="right">
                            {subscription.invoiceUrl ? (
                              <a href={subscription.invoiceUrl} target="_blank">
                                View Invoice
                              </a>
                            ) : (
                              "-"
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : !isLoading && (
                      <TableRow>
                        <TableCell
                          style={{ textAlign: "center" }}
                          colSpan="5"
                          className="store-no-data"
                        >
                          No records found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </Col>
      </Row>
      <Snackbar
        // open={open}
        // autoHideDuration={openUpdatePassword ? 10000 : 2000}
        // onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          // onClose={handleClose}
          // severity={snackClr}
          sx={{ width: "100%" }}
        >
          {/* {snackMsg} */}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default UserSubscription;